<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug">

  form(v-on:submit.prevent="handleSubmit")

    c-form-error(v-bind:message="$t(responseErrorMessage)")

    div.form-group
      input(autofocus type="number" name="code" v-bind:placeholder="$t('placeholder_code')" v-model="model.code")

    div(v-if="timerCounts > 0")
      div(v-if="seconds > 0")
        span(v-bind:class="(seconds !== 0) ? 'disabled' : ''") {{ $tc('label_resending_code', seconds, { seconds: seconds }) }}
      div(v-else)
        .link-resend-code(v-on:click.stop="resendCode") {{ $t('link_resend_code') }}

    c-form-submit(v-bind:isDisabled="isInvalidRequestParams()" v-bind:isLoading="requestBeingProcessed") {{ $t('btn_check_security_code') }}

</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import * as errorCodes from 'classes/error-codes';
import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import mFormSubmit from 'mixins/formSubmit';
import mMask from 'mixins/mask';
import * as types from 'store/mutation-types';

export default {
  mixins: [mMask, mFormSubmit],

  components: {
    cFormError,
    cFormSubmit,
  },

  data() {
    return {
      isLoading: false,
      errorMessage: '',
      code: '',
      seconds: 0,
      timerId: null,
      timerCounts: 5,
      model: {
        code: null,
      },
    };
  },

  validations: {
    model: {
      code: {
        required,
        minLength: minLength(4),
      },
    },
  },

  computed: {
    ...mapGetters('registration', ['email']),
  },

  mounted() {
    this.$store.commit(`registration/${types.SET_EMAIL_CODE}`, null);
    this.$store.commit(`registration/${types.SET_EMAIL_CODE_VALID}`, false);
  },

  methods: {
    onBeforeRequest() {
      this.mask();
    },

    onAfterRequest() {
      this.unmask();
    },

    handleRequestUrl() {
      return '/security-code/check-code';
    },

    handleRequestParams() {
      return {
        recipient: this.email,
        security_code: this.model.code,
      };
    },

    /**
     * Обработка ответа формы
     */
    handleResponse(response) {
      switch (this.getResponceStatusCode(response)) {
        // Код прошел валидацию
        case responseCodes.RESPONSE_SECURITY_CODE_IS_VALID:
          // Сохраняем данные о коде
          this.$store.commit(`registration/${types.SET_EMAIL_CODE}`, this.model.code);
          this.$store.commit(`registration/${types.SET_EMAIL_CODE_VALID}`, true);

          // Проверяем email на валидность
          this.$http
            .post('/email/check-email', { email: this.email })

            .then((response) => {
              switch (this.getResponceStatusCode(response)) {
                // Email уже был подтвержден,
                // значит пользователь зареган и нужно ввести пароль
                case responseCodes.RESPONSE_EMAIL_CONFIRMED:
                  this.$router.push({ name: 'enter-password' });
                  break;
              }

              switch (this.getResponceErrorCode(response)) {
                // Тонкий момент!
                // Email существует, но не подтвержден или Email не существует:
                // в любом случае отправляем на регу, там разберемся
                case errorCodes.ERROR_EMAIL_IS_NOT_CONFIRMED:
                case errorCodes.ERROR_EMAIL_DOES_NOT_EXIST:
                  this.$router.push({
                    name: 'registration',
                    params: {
                      isValidated: true,
                      action: 'submit',
                    },
                  });

                  break;
              }
            })
            .catch((error) => {
              this.catchResponseError(error);
            });

          break;
      }
    },

    /**
     * Повторная отправка кода
     */
    resendCode() {
      this.timerCounts--;
      if (this.timerCounts > 0) {
        this.timer(60);

        // Проверяем номер телефона
        this.$http
          .post('/email/send-security-code', {
            token_scope: 'registration',
            email: this.email,
          })
          .then((response) => {
            if (this.isSuccessfulRequest(response)) {
              switch (this.getResponceStatusCode(response)) {
                case responseCodes.RESPONSE_SECURITY_CODE_WAS_SENT:
                  break;
                default:
                  this.setResponseError('Ошибка генерации токена');
              }
            }
          })
          .catch((error) => {
            this.catchResponseError(error);
          });
      }
    },

    /**
     * Запуск таймера
     * @param seconds
     */
    timer(seconds = null) {
      if (seconds) {
        this.seconds = seconds;
      }

      this.timerId = window.setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          window.clearInterval(this.timerId);
        }
      }, 1000);
    },
  },
};
</script>
